<template>
    <v-card>
        <v-data-table
            :items="unit.meterResets"
            :items-per-page="options.itemsPerPage"
            :headers="headers"
            :footer-props.sync="footerProps"
            :options.sync="options"
        >
            <template v-slot:item="items">
                <tr>
                    <td>{{items.item.resetDate | formatDate }}</td>
                    <td>{{items.item.hoursBefore }}</td>
                    <td>{{items.item.hoursAfter }}</td>
                    <td>{{items.item.kilometresBefore }}</td>
                    <td>{{items.item.kilometresAfter }}</td>
                    <td v-if="!unit.isDeleted && (userIsFleetManager || userIsDataEntryInGarage(unit.garageLocationId, userGarages))">
                        <v-btn @click="openEdit(items.item)" icon>
                            <v-icon>edit</v-icon>
                        </v-btn>
                        <v-btn v-if="userIsFleetManager" @click="confirmDelete(items.item)" icon small color="red">
                            <v-icon>delete</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <v-card-actions v-if="!disabled">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="openAdd()">Add Meter Reset</v-btn>
            <v-dialog v-model="dialog" max-width="500px" persistent>
                <Form v-model="model" @close="dialog = false">
                    <template v-slot:header>
                        <v-spacer></v-spacer>
                        <v-btn @click="dialog=false" icon text>
                            <v-icon>close</v-icon>
                        </v-btn>
                    </template>
                </Form>
            </v-dialog>
        </v-card-actions>
    </v-card>
</template>
<script>
import Form from './Form.vue';
import GarageLocationsClient from '@/components/GarageLocations/GarageLocationsClient.vue';
import { Event } from '@/plugins/bus';

export default {
    mixins: [GarageLocationsClient],
    components: {
        Form
    },
    props: {
        unit: {
            required: true
        }
    },
    data() {
        return {
            dialog: false,
            model: {},
            options: {
                sortBy: ['resetDate', 'createdDate']
            },
            footerProps: {
                itemsPerPageOptions: [10, 50, 100]
            },
            headers: [
                { text: 'Date', value: 'resetDate', sortable: false },
                { text: 'Hours', value: 'resetAtHours', sortable: false },
                { text: 'Reset to', value: 'resetToHours', sortable: false },
                { text: 'Kilometres', value: 'resetAtKilometres', sortable: false },
                { text: 'Reset to', value: 'resetToKilometres', sortable: false },
                { text: '', value: 'actions', sortable: false }
            ]
        };
    },
    computed: {
        disabled() {
            const g = this.unit.garageLocationId;
            return this.unit.isDeleted
              || (!this.userIsWorkshopManagerInGarage(g, this.userGarages)
              && !this.userIsDataEntryInGarage(g, this.userGarages)
              && !this.userIsFleetManager);
        }
    },
    methods: {
        openAdd() {
            this.model = {
                unitId: this.unit.id,
                hoursBefore: null,
                hoursAfter: null,
                kilometresBefore: null,
                kilometresAfter: null
            };
            this.dialog = true;
        },
        openEdit(meterReset) {
            this.model = {
                ...meterReset, // spread operator intentionally used to create clone
                unitId: this.unit.id
            };
            this.dialog = true;
        },
        confirmDelete(meterReset) {
            this.$confirmCancel.show(`Delete Meter Reset?`, `<p>This will permanently delete this meter reset record</p>`, 'Delete it');
            this.$confirmCancel.$on('confirm-cancel', confirmed => {
                if (!confirmed) {
                    return;
                }
                this.$bus.$emit(Event.UnitMeterResetPendingDelete, {
                    id: meterReset.id,
                    unitId: this.unit.id
                });
            });
        },
        closeDialog() {
            this.dialog = false;
        }
    },
    mounted() {
        this.$bus.$on(Event.UnitMeterResetPendingAdd, this.closeDialog);
        this.$bus.$on(Event.UnitMeterResetPendingUpdate, this.closeDialog);
    },
    destroyed() {
        this.$bus.$off(Event.UnitMeterResetPendingAdd, this.closeDialog);
        this.$bus.$off(Event.UnitMeterResetPendingUpdate, this.closeDialog);
    }
};
</script>
